import { call, put, takeEvery } from 'redux-saga/effects'
import nautilusApi from '../../nautilusApi'
import { stripBadPatternIds } from './utils'
import {
  fetchRequest,
  fetchResponse,
  mitreAttackActorsRequest,
  mitreAttackMalwareRequest,
  mitreAttackResponse
} from './actions'

export function * handleFetchRequest(action) {
  const { path: unprefixedPath, body, ...options } = action.payload
  const { ns } = action.meta
  const path = `/api${unprefixedPath}`

  if (body) {
    options.body = typeof body === 'string' ? body : JSON.stringify(body)
  }

  yield put(fetchResponse(ns, undefined))

  try {
    const data = yield call(nautilusApi.fetch, path, options)
    yield put(fetchResponse(ns, data))
  } catch (error) {
    yield put(fetchResponse(ns, error))
  }
}

export function * handleMitreAttackActorRequest(action) {
  const { ids } = action.payload
  const path = '/api/v4/actor/attack-pattern/'

  const options = {
    method: 'POST',
    body: JSON.stringify({ ids })
  }

  try {
    const response = yield call(nautilusApi.fetch, path, options)
    const items = response['threat-actors']
    stripBadPatternIds(items)
    const data = { items, 'attack-patterns': response['attack-patterns'] }
    yield put(mitreAttackResponse({ ids, data }))
  } catch (error) {
    yield put(mitreAttackResponse({ error }))
  }
}

export function * handleMitreAttackMalwareRequest(action) {
  const { ids } = action.payload
  const path = '/api/v4/malware/attack-pattern/'

  const options = {
    method: 'POST',
    body: JSON.stringify({ ids })
  }

  try {
    const response = yield call(nautilusApi.fetch, path, options)
    const data = { items: response.malware, 'attack-patterns': response['attack-patterns'] }
    yield put(mitreAttackResponse({ ids, data }))
  } catch (error) {
    yield put(mitreAttackResponse({ error }))
  }
}

export default function * saga() {
  yield takeEvery(fetchRequest, handleFetchRequest)
  yield takeEvery(mitreAttackActorsRequest, handleMitreAttackActorRequest)
  yield takeEvery(mitreAttackMalwareRequest, handleMitreAttackMalwareRequest)
}
